module.exports = __webpack_public_path__ + "img/Plan 3-1.1ada732b.jpg";